
import Vue from 'vue';
import Modal from '@/components/modal/index.vue';

export default Vue.extend({
  components: {
    Modal,
  },
  props: {
    modalId: {
      type: String,
      required: true,
    },
    opened: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
});
